import { render } from "./OrderSparePartsTable.vue?vue&type=template&id=c13d6668&ts=true&lang=pug"
import script from "./OrderSparePartsTable.vue?vue&type=script&lang=ts"
export * from "./OrderSparePartsTable.vue?vue&type=script&lang=ts"

import "./OrderSparePartsTable.vue?vue&type=style&index=0&id=c13d6668&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__